import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SocialProof = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        axios.get(`${API}/stats/social-proof`)
            .then(({ data }) => setStats(data))
            .catch(() => setStats(null));
    }, []);

    if (!stats) return null;

    const items = [
        { value: stats.owners_total, label: "Abundance Owners" },
        { value: stats.owners_this_week, label: "Joined This Week" },
        { value: stats.seats_reserved, label: "Seats Reserved for Tuesday" },
    ];
    const empty = items.every((i) => !i.value);

    return (
        <motion.div
            data-testid="social-proof-strip"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative border-y border-orchid/20 bg-[#0E0818]/80"
        >
            <div className="max-w-5xl mx-auto px-5 sm:px-8 py-10 sm:py-12">
                {empty ? (
                    <div className="flex items-center justify-center gap-3 text-center">
                        <Flame className="w-4 h-4 text-gold shrink-0" />
                        <p data-testid="social-proof-founding" className="font-mono text-[11px] sm:text-xs tracking-[0.25em] uppercase text-zinc-400">
                            The founding circle is forming now — <span className="text-gold">be one of the first</span>
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-3 gap-4 sm:gap-8 text-center">
                        {items.map((item) => (
                            <div key={item.label} data-testid={`social-proof-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                                <span className="block font-serif text-3xl sm:text-4xl gold-text">{item.value}</span>
                                <span className="block font-mono text-[9px] sm:text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-2">{item.label}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </motion.div>
    );
};
